export const parseNextBusinessPartnerNumberResponse = (response) => {
  const body = response?.body ?? response ?? {}
  const data = body.data

  if (data != null && typeof data === 'object' && !Array.isArray(data) && 'number' in data) {
    return { number: data.number, accountNo: data.accountNo ?? data.number }
  }

  return { number: data, accountNo: body.meta?.accountNo ?? body.accountNo ?? data }
}
